import React, { Component } from 'react';
import AreaChartComponent from './AreaChart';

class CustomXTick extends Component {
  getYear() {
    return parseInt(this.props.payload.value) + new Date().getFullYear();
  }

  getUserAge() {
    return this.props.payload.value + this.props.user.age;
  }

  getSpouseAge() {
    return this.getYear() - (new Date().getFullYear() - this.props.spouse.age);
  }

  render() {
    const { x, y, index } = this.props;
    return (
      <g transform={`translate(${x},${y})`}>
        <text x={0} y={0} dy={16} textAnchor="middle" fill="#666">
          {this.getYear()}
        </text>
        <text x={0} y={0} dy={32} textAnchor="middle" fill="#666">
          {this.getUserAge()}
        </text>
        {this.props.partnerPerson != null && (
          <text x={0} y={0} dy={48} textAnchor="middle" fill="#666">
            {this.getSpouseAge()}
          </text>
        )}
        {index == 0 && (
          <g>
            <text x={0} y={0} dx={-20} dy={16} textAnchor="end" fill="#666">
              Year:
            </text>
            <text x={0} y={0} dx={-20} dy={32} textAnchor="end" fill="#666">
              Your Age:
            </text>
            {this.props.spousePerson != null && (
              <text x={0} y={0} dx={-20} dy={48} textAnchor="end" fill="#666">
                Spouse Age:
              </text>
            )}
          </g>
        )}
      </g>
    );
  }
}

export default class AssetBalanceChart extends Component {
  constructor(props) {
    super(props);

    this.state = {
      width: 600,
    };
  }

  componentDidMount() {
    this.setState({
      width: document.getElementsByClassName('container-width')[0]
        ? document.getElementsByClassName('container-width')[0].offsetWidth - 90
        : 600,
    });
  }

  getXTicks() {
    // return [0, 5, 10, 20];
    let ticks = [];
    const currAge = this.props.primaryPerson.age;
    for (const [index, entry] of this.props.initial.distribution.asset_balance.average.entries()) {
      if (index == 0) {
        continue;
      }
      if ((currAge + index) % 10 == 0) {
        ticks.push(index);
      }
    }
    return ticks;
  }

  render() {
    if (!this.props.initial.distribution) {
      return null;
    }

    const { width } = this.state;
    const { initial, updated } = this.props;

    const analyzeData = (beforeData, afterData) => {
      let planningData = beforeData.distribution.asset_balance.average.map((entry, index) => {
        let obj = {};
        obj['date'] = index;
        obj['before'] = entry;
        if (afterData) {
          obj['after'] = afterData.distribution.asset_balance.average[index];
        } else {
          obj['after'] = entry;
        }
        obj['change'] = obj['after'] - obj['before'];
        return obj;
      });
      planningData.pop();
      return planningData;
    };

    const renderedData = analyzeData(initial, updated);

    return (
      <div className="hrbr-recharts">
        <AreaChartComponent
          xTick={<CustomXTick user={this.props.primaryPerson} spouse={null} />}
          xTicks={this.getXTicks()}
          xAxisHeight={this.props.partnerPerson == null ? 45 : 60}
          data={renderedData}
          width={width}
          proposed={!!this.props.updated}
          beforeLegend={this.props.beforeLegend}
          afterLegend={this.props.afterLegend}
          afterColor={this.props.afterColor}
          useAfterLine={this.props.useAfterLine}
        />
      </div>
    );
  }
}
